import { Box, Center, chakra, Progress } from "@chakra-ui/react";
import React from "react";

const Loader = () => {
  return (
    <>
      {/* <Center h="100%" fontSize="3xl" color="blue.500">
      <TextIcon fill="none">
        <svg id="logo" fill="currentColor" viewBox="0 0 328 328">
          <path fillRule="evenodd" clipRule="evenodd"
            d="M164 328C254.575 328 328 254.575 328 164C328 73.4253 254.575 0 164 0C73.4253 0 0 73.4253 0 164C0 254.575 73.4253 328 164 328ZM241.026 162.758V162.761L241.029 162.758V238.545H165.242L165.239 238.545C123.383 238.545 89.4521 204.614 89.4521 162.758C89.4521 120.902 123.383 86.9709 165.239 86.9709C207.095 86.9709 241.026 120.902 241.026 162.758Z" />
        </svg>
      </TextIcon>
    </Center> */}

      <Center minH="280px" flexDir="column" padding="6" w="100%" h="100%">
        <Box margin="auto" display="flex" flexDir="column" alignItems="center" justifyContent="center">
          <chakra.svg w="48px" h="auto" viewBox="0 0 512 512">
            <path
              d="M140.114,80.528,76.9,136.492V345.073l86.4,86.4H371.884l63.21-55.964H226.512l-84.28-84.28Z"
              fill="#070707"
              fillRule="evenodd"
            />
            <path
              d="M140.114,80.528,76.9,136.492V345.073l86.4,86.4H371.884l63.21-55.964H226.512l-84.28-84.28ZM123.156,118.7,94.247,144.3V337.89l76.239,76.242H365.309l24.04-21.281H226.512a17.355,17.355,0,0,1-12.263-5.08l-84.28-84.28a17.338,17.338,0,0,1-5.076-12.088Z"
              fill="#070707"
              fillRule="evenodd"
            />
            <path
              d="M140.116,289.117V80.531H389.058L435.1,122.672V375.511H226.516Zm30.348-178.238V276.547l68.622,68.616H404.749V136.037l-27.484-25.158Z"
              fill="#070707"
              fillRule="evenodd"
            />
            <path d="M279.324,185.949H239.263v88.892H329.75V237.172H279.324Z" fill="#070707" />
          </chakra.svg>

          <Progress height="4px" isIndeterminate width="40px" color="primary.500" />
        </Box>
      </Center>
    </>
  );
};

export default Loader;
